/**
 * Hash-query plumbing shared by the estate planning local-dev mocks (development only).
 * `HashRouter` keeps the query after the route (`#/estate-planning?epMock=…`), so both
 * reading a deeplink and writing one from `window.__dspEstatePlanningMock` go through here.
 */

export const ESTATE_DEV_MOCK_SCENARIO_URL_PARAM = 'epMock';
export const ESTATE_DEV_MOCK_ELIGIBILITY_URL_PARAM = 'epEligibility';

function splitHash(): {route: string; params: URLSearchParams} {
  const hash = window.location.hash.replace(/^#/, '');
  const queryStart = hash.indexOf('?');

  if (queryStart === -1) {
    return {route: hash, params: new URLSearchParams()};
  }

  return {route: hash.slice(0, queryStart), params: new URLSearchParams(hash.slice(queryStart + 1))};
}

export function getEstateDevMockHashParam(name: string): string | null {
  return splitHash().params.get(name);
}

/** Adds, replaces, or (with `value: null`) removes one param, leaving the route and other params intact. */
export function setEstateDevMockHashParam(name: string, value: string | null): void {
  const {route, params} = splitHash();

  if (value === null) {
    params.delete(name);
  } else {
    params.set(name, value);
  }

  const query = params.toString();
  window.location.hash = `#${route}${query ? `?${query}` : ''}`;
}
